/**
 * @desc 导出费用请款to单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.costRequest.exportCostRequestToReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/exportCostRequestToReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
